import React from 'react';
import TooltipOnHover from './TooltipOnHover';

const TooltipQuestionIcon = (props) => {
  const { targetId = `tooltip_${Math.ceil(Math.random() * Math.pow(2, 5))}_id`, textDisplay, children } = props;
  const plainText = textDisplay.replace(/<[^>]*>/g, '');
  return (
    <React.Fragment>
      <TooltipOnHover msg={textDisplay} target={targetId} />
      {children}{' '}
      <div
        tabIndex="0"
        role='status'
        id={targetId}
        aria-label={`${children || ''} ${plainText} tooltip`.trim()}
        className="far fa-question-circle fontSm-15"></div>
    </React.Fragment>
  );
};

export default TooltipQuestionIcon;
